import type { FC } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {}

/** hackity hack to close muro's login modal... */
const MuroModalClosePage: FC<Props> = () => {
  const { t } = useTranslation();
  useEffect(() => {
    try {
      (window as any).parent.Modals.pop({
        _source: 'signup',
        result: 'finished',
        pageData: { 'deviantART.user_agreed_to_submission_policy': true },
      });
    } catch {
      // probably some weird cross frame bs again... so let the user do it themselves
    }
  }, []);

  return (
    <div>
      <h2>{t('sisu.muroClose.heading')}</h2>
      {t('sisu.muroClose.message')}
    </div>
  );
};
MuroModalClosePage.displayName = 'MuroModalClosePage';

export default MuroModalClosePage;
